import { envSettings } from "core/EnvSettings";
export const OrderService = {
	reloadCarCar: 1,
	reloadCarTerminalCar: 2,
	intoPlukkStorage: 3,
	crossDock: 4,
	coldStorage: 5,
	per: 6,
	[null]: null,
};

const reloadCarCarFullName = envSettings.REACT_APP_RELOAD_CAR_CAR__FULL_NAME ?? "Reload Car-Car";
const reloadCarTerminalCarFullName =
	envSettings.REACT_APP_RELOAD_CAR_TERMINAL_CAR__FULL_NAME ?? "Reload Car-Terminal-Car";
const intoPlukkStorageFullName =
	envSettings.REACT_APP_INTO_PLUKK_STORAGE__FULL_NAME ?? "Into Plukk Storage";
const intoPlukkStorageFullNameForOrderImport =
	envSettings.REACT_APP_INTO_PLUKK_STORAGE__FULL_NAME_FOR_ORDER_IMPORT ?? "OP";
const crossDockFullName = envSettings.REACT_APP_CROSS_DOCK__FULL_NAME ?? "Cross Dock";

const reloadCarCarHidden = envSettings.REACT_APP_RELOAD_CAR_CAR__HIDDEN;
const reloadCarTerminalCarHidden = envSettings.REACT_APP_RELOAD_CAR_TERMINAL_CAR__HIDDEN;
const intoPlukkStorageHidden = envSettings.REACT_APP_INTO_PLUKK_STORAGE__HIDDEN;
const crossDockHidden = envSettings.REACT_APP_CROSS_DOCK__HIDDEN;
const perFullName = envSettings.REACT_APP_PER__FULL_NAME;

const coldStorageFullName = envSettings.REACT_APP_COLD_STORAGE__FULL_NAME;

export const OrderServicesHidden = {
	[OrderService.reloadCarCar]: reloadCarCarHidden,
	[OrderService.reloadCarTerminalCar]: reloadCarTerminalCarHidden,
	[OrderService.intoPlukkStorage]: intoPlukkStorageHidden,
	[OrderService.crossDock]: crossDockHidden,
};

export const OrderServiceNames = {
	[OrderService.reloadCarCar]: reloadCarCarFullName,
	[OrderService.reloadCarTerminalCar]: reloadCarTerminalCarFullName,
	[OrderService.intoPlukkStorage]: intoPlukkStorageFullName,
	[OrderService.crossDock]: crossDockFullName,
	[OrderService.coldStorage]: coldStorageFullName,
	[OrderService.per]: perFullName,
};

export const OrderServiceChoices = [
	{ id: OrderService.reloadCarCar, name: OrderServiceNames[OrderService.reloadCarCar] },
	{
		id: OrderService.reloadCarTerminalCar,
		name: OrderServiceNames[OrderService.reloadCarTerminalCar],
	},
	{ id: OrderService.intoPlukkStorage, name: OrderServiceNames[OrderService.intoPlukkStorage] },
	{ id: OrderService.crossDock, name: OrderServiceNames[OrderService.crossDock] },
	{ id: OrderService.coldStorage, name: OrderServiceNames[OrderService.coldStorage] },
	{ id: OrderService.per, name: OrderServiceNames[OrderService.per] },
];

export const perEligibleServices = [
	OrderService.reloadCarCar,
	OrderService.crossDock,
	OrderService.intoPlukkStorage,
];

export const etdThirdAssigneeServices = [OrderService.crossDock, OrderService.intoPlukkStorage];

export const thirdAssigneeEligibleServices = [
	OrderService.coldStorage,
	...etdThirdAssigneeServices,
];

export const OrderServices = {
	[OrderService.reloadCarCar]: {
		full_name: reloadCarCarFullName,
		short_name: envSettings.REACT_APP_RELOAD_CAR_CAR__SHORT_NAME,
	},
	[OrderService.reloadCarTerminalCar]: {
		full_name: reloadCarTerminalCarFullName,
		short_name: envSettings.REACT_APP_RELOAD_CAR_TERMINAL_CAR__SHORT_NAME,
	},
	[OrderService.intoPlukkStorage]: {
		full_name: intoPlukkStorageFullName,
		short_name: envSettings.REACT_APP_INTO_PLUKK_STORAGE__SHORT_NAME,
	},
	[OrderService.crossDock]: {
		full_name: crossDockFullName,
		short_name: envSettings.REACT_APP_CROSS_DOCK__SHORT_NAME,
	},
	[OrderService.coldStorage]: {
		full_name: coldStorageFullName,
		short_name: envSettings.REACT_APP_COLD_STORAGE__SHORT_NAME,
	},
	[OrderService.per]: {
		full_name: perFullName,
		short_name: envSettings.REACT_APP_PER__SHORT_NAME,
	},
};
